import VideoHomePageList from "./VideoHomePageList.container";

export default VideoHomePageList;
